<div class="p-inputgroup">
  <p-slider
    attr.name="{{ inputName }}"
    [formControl]="control"
    [min]="0"
    [max]="200"
    [step]="1"
    (onChange)="handleChange($event)"
    (onSlideEnd)="handleSlideEnd($event)"
  ></p-slider>
  <input
    pInputText
    type="text"
    readonly
    value="{{ control.value | hoursToDays: 24 }}"
    class="p-inputgroup-addon sliderInput sliderInput-width"
  />
</div>
